import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import {
  aiPlanFilterBarSx,
  aiPlanFilterFieldSx,
} from "../../../constants/regulationDetailsNavTabStyles";

export type TriagePlanProcessFlowOption = Readonly<{
  code: string;
  name: string;
}>;

type TriagePlanFilterBarProps = Readonly<{
  processFlow: string;
  processFlowOptions: readonly TriagePlanProcessFlowOption[];
  loading?: boolean;
  onProcessFlowChange: (processFlow: string) => void;
}>;

/** Process Flow filter for Triage Plan list (matches empty-state design). */
export default function TriagePlanFilterBar({
  processFlow,
  processFlowOptions,
  loading = false,
  onProcessFlowChange,
}: TriagePlanFilterBarProps) {
  return (
    <Box sx={aiPlanFilterBarSx}>
      <TextField
        select
        size="small"
        label="Process Flow"
        value={processFlow}
        disabled={loading}
        sx={aiPlanFilterFieldSx}
        onChange={(event) => onProcessFlowChange(event.target.value)}
        SelectProps={{
          MenuProps: {
            PaperProps: { sx: { maxHeight: 300 } },
          },
        }}
      >
        <MenuItem value="">All</MenuItem>
        {processFlowOptions.map((option) => (
          <MenuItem key={option.code} value={option.code}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
